import { render, staticRenderFns } from "./apiMenu.vue?vue&type=template&id=5cf758c0&scoped=true&"
import script from "./apiMenu.vue?vue&type=script&lang=js&"
export * from "./apiMenu.vue?vue&type=script&lang=js&"
import style0 from "./apiMenu.vue?vue&type=style&index=0&id=5cf758c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf758c0",
  null
  
)

export default component.exports